<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="userRoleForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                userRoleForm: () => import('../forms/UserRoleForm'),
                headers: [
                    { text: 'User', value: 'userId', table: 'users', form: () => import('../forms/UserForm') },
                    { text: 'Role', value: 'roleId', table: 'roles', form: () => import('../forms/RoleForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    roles: [],
                    users: [],
                    items: []
                },
                sorting: [
                    { column: "userId", direction: "ascending" },
                    { column: "roleId", direction: "ascending" },
                ],
                itemsField: 'userRoles',
                editPageName: 'userRole',
                apiMethod: 'UserRoles',
                claimName: 'UserRoles',
                formTitle: 'User Role',
                excelTitle: 'User Roles',
                hasEditPage: false,
            }
        },
    };
</script>
